function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-1.4034e-06 5.89388C-1.23052e-06 9.84898 1.10063 13.2612 1.10063 19C1.10063 24.7388 -4.27123e-07 28.2286 -2.5763e-07 32.1061C-8.47466e-08 36.0612 2.98742 38 5.2673 38C7.54717 38 9.51258 36.449 12.4214 33.9673C15.3302 31.5633 19.8113 27.3755 21.2264 25.8245C22.6415 24.2735 25 22.6449 25 19C25 15.3551 22.6415 13.7265 21.2264 12.1755C19.8113 10.6245 15.3302 6.43673 12.4214 4.03265C9.51258 1.62857 7.54717 -3.29897e-07 5.26729 -2.30241e-07C2.98742 -1.30584e-07 -1.57629e-06 1.93877 -1.4034e-06 5.89388Z",
  fill: "#DEAD00"
});

var SvgNextPage = function SvgNextPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 38,
    viewBox: "0 0 25 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next-page.2195295f.svg";
export { ForwardRef as ReactComponent };